var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import LinearProgress from '@mui/material/LinearProgress';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
export function LinearProgressBar(props) {
    return (React.createElement(Box, { component: "div", display: "flex", alignItems: "center" },
        React.createElement(Box, { component: "div", width: "100%", mr: 1 },
            React.createElement(LinearProgress, __assign({ color: "secondary", variant: "determinate" }, props))),
        React.createElement(Box, { component: "div", minWidth: 35 },
            React.createElement(Typography, { variant: "body2" }, "".concat(Math.floor(props.value), "%")))));
}
